module.exports = __webpack_public_path__ + "static/media/bold.1a53343e.png";